import React from "react";
import classNames from "classnames";
import { Tooltip } from "antd";

const SwKpi = ({
  label,
  value,
  loading = false,
  active = false,
  tooltip,
  variant, // success | danger | warning | info | orange | purple | teal | indigo | cyan | pink | grey | dark
  width,
  onClick,
  className = "",
}) => {
  const content = (
    <div
      className={classNames(
        "SwKpiBox",
        active && "active",
        loading && "SwKpiBox-loading",
        variant && `SwKpiBox-${variant}`,
        onClick && "cursor-pointer",
        className
      )}
      style={{ minWidth: width }}
      onClick={onClick}
    >
      <p className="KpiText">{label}</p>

      <h3 className="KpiNumber">
        {loading ? (
          <div className="lds-ellipsis">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        ) : (
          value
        )}
      </h3>
    </div>
  );

  return tooltip ? (
    <Tooltip title={tooltip}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default SwKpi;
